import React from "react";
import { Customer } from "@/api/customers";
import {
  MultipleSelectDataGrid,
  DataGridColumn,
} from "@/ui-controls/DataGrid";
interface Props {
  CustomerList: Customer[];
  onSelectionChanged: (selectedList: Customer[]) => any;
}

const CustomerSelectDetailList = (props: Props) => {
  const columns: DataGridColumn[] = [
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "Description",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
  ];

  return (
    <>
      <MultipleSelectDataGrid
        items={props.CustomerList}
        columns={columns}
        onSelectionChanged={props.onSelectionChanged}
      />
    </>
  );
};

export default CustomerSelectDetailList;
